import { render, staticRenderFns } from "./MajorSubjectCreate.vue?vue&type=template&id=5823b828&scoped=true&"
import script from "./MajorSubjectCreate.vue?vue&type=script&lang=js&"
export * from "./MajorSubjectCreate.vue?vue&type=script&lang=js&"
import style0 from "./MajorSubjectCreate.vue?vue&type=style&index=0&id=5823b828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5823b828",
  null
  
)

export default component.exports